import { getRandomChildren } from '@sola/proxy-sdk/children.ts';
import { CartItemTypeEnum } from '@sola/schema/dotcom/cart/cart-item.js';
import { SponsorshipItemTypeEnum } from '@sola/schema/dotcom/cart/sponsorship.js';
import { UpsellSponsorshipItem } from '@sola/schema/dotcom/checkout/upsell.js';

/**
 * @description Return the structure Fund item data
 *
 * NOTE: current tmc ID is 'tcm:5-102864-16'
 * alternative tcm: 'tcm:5-126684-16'???
 */
// RESOLVE: determine the future use/necessity of this method.
// export const getUpsellFundItem = async (tcmId = 'tcm:5-102864-16'): Promise<UpsellFundItem | null | undefined> => {
//     throw new Error('IMPORTANT: LOGIC NOT IMPLEMENTED/IN USE!!!');
//     // return process.env.NODE_ENV !== 'development' ? await getContentDataByType(ContentTypesEnum.Funds, tcmId) as UpsellFundItem
//     // : {
//     //     "id": "AylYwZ-i-lpKKBFHvZPWK",
//     //     "commitmentFrequency": CommitmentFrequencyEnum.Monthly,
//     //     "unitPrice": 15,
//     //     "amount": 15,
//     //     "added": "2024-07-17T16:47:59.703Z",
//     //     "itemType": CartItemTypeEnum.Fund,
//     //     "title": "Where Most Needed Fund",
//     //     "fund": { "cmsId": "tcm:5-102864-16", "fundCode": "MN" }
//     // }
// }

/**
 * @description Get a Rich Mix child & return the structure Sponsorship item data
 */
export const getUpsellSponsorshipItem = async (): Promise<
  UpsellSponsorshipItem | null | undefined
> => {
  const { children } = (await getRandomChildren()) || {};
  const child = children?.[0];

  if (!child) {
    return null;
  }

  return {
    itemType: CartItemTypeEnum.Sponsorship,
    sponsorship: {
      sponsorshipType: SponsorshipItemTypeEnum.Selected,
      globalId: child.globalId,
      sourceCode: child.sourceCode || '',
    },
    ...(child && {
      child,
    }),
  };
};
